import { useState } from "react";
import axios from "../api/client";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function PasswordResetRequestPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  async function submit(event) {
    event.preventDefault();
    setSubmitting(true);
    try {
      await axios.post("/api/password-reset/request", { email }, { withCsrf: false });
      setMessage(t("passwordReset.requestAccepted"));
    } finally { setSubmitting(false); }
  }
  return <div className="max-w-md mx-auto bg-white border rounded-xl shadow p-6 mt-10">
    <h1 className="text-2xl font-semibold mb-2 text-center">{t("passwordReset.requestTitle")}</h1>
    <p className="text-sm text-gray-600 mb-4">{t("passwordReset.requestDescription")}</p>
    <form onSubmit={submit} className="space-y-4">
      <label className="block text-sm font-medium text-gray-600">{t("login.email")}
        <input type="email" value={email} onChange={(event) => setEmail(event.target.value)} autoComplete="email" required className="w-full border rounded-lg px-3 py-2 mt-1" />
      </label>
      {message && <p className="text-green-700 text-sm">{message}</p>}
      <button type="submit" disabled={submitting} className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 disabled:opacity-60">{t("passwordReset.requestSubmit")}</button>
      <p className="text-center text-sm"><Link className="text-blue-700 hover:underline" to="/login">{t("passwordReset.backToLogin")}</Link></p>
    </form>
  </div>;
}
